import { render, staticRenderFns } from "./dept-member-cusMgrLeader-list.vue?vue&type=template&id=36d58957&scoped=true"
import script from "./dept-member-cusMgrLeader-list.vue?vue&type=script&lang=js"
export * from "./dept-member-cusMgrLeader-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d58957",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d58957')) {
      api.createRecord('36d58957', component.options)
    } else {
      api.reload('36d58957', component.options)
    }
    module.hot.accept("./dept-member-cusMgrLeader-list.vue?vue&type=template&id=36d58957&scoped=true", function () {
      api.rerender('36d58957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/dept-member-cusMgrLeader-list.vue"
export default component.exports